import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/profile/arrow_right_white45.png'


const _hoisted_1 = { class: "menu-section" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "menu-left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "menu-text" }
const _hoisted_6 = {
  key: 0,
  class: "sub_text"
}

import { ref, inject } from 'vue'
import { useRouter } from 'vue-router'
import { clickOnMenu, MENU_LIST_THEME_TWO } from '@/view/profile/supportScript'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'menuCard',
  emits: ['logout'],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const menuList = ref(MENU_LIST_THEME_TWO)
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)
const emits = __emit
const openLogoutPopup = inject<() => void>('openLogoutPopup')

const handleLogoutClick = () => {
  openLogoutPopup?.()
}

const onMenuClick = (path: string | null, index: number) => {
  clickOnMenu(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-title" }, "Outros", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["menu-card", { 'pop-animate': poppingIndex.value === index }]),
          key: index,
          onClick: ($event: any) => (onMenuClick(item.path, index))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: item.img,
              alt: "",
              class: "menu-icon"
            }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(item.name)), 1),
            (item.msg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t(item.msg)), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "arrow-icon"
          }, null, -1))
        ], 10, _hoisted_2))
      }), 128))
    ]),
    _createVNode(ContactServicePopup, {
      ref_key: "contactServiceRef",
      ref: contactServiceRef
    }, null, 512)
  ], 64))
}
}

})